import { InjectionToken } from '@angular/core';
import { IAuthStorageStrategy } from '../classes/IAuthStorageStrategy';

export const AUTH_STORAGE = new InjectionToken<IAuthStorageStrategy>('Auth storage implementation');
